module.exports = __webpack_public_path__ + "static/media/crime_alert_small.9b147bfd.png";